import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStatus } from "../hooks/useAuthStatus";
import FullScreenSpinner from "../components/Common/FullScreenSpinner";

const VERIFY_EMAIL_PATH = "/verify-email";

const Authmiddleware = ({ children }) => {
    const { isAuthenticated, isLoading, isEmailVerified } = useAuthStatus();
    const location = useLocation();
    const requestedUrl = location.pathname + location.search;

    if (isLoading) {
        return <FullScreenSpinner />;
    }

    if (!isAuthenticated) {
        return <Navigate to={`/login?returnUrl=${encodeURIComponent(requestedUrl)}`} replace />;
    }

    if (!isEmailVerified && location.pathname !== VERIFY_EMAIL_PATH) {
        return <Navigate to={`${VERIFY_EMAIL_PATH}?returnUrl=${encodeURIComponent(requestedUrl)}`} replace />;
    }

    if (isEmailVerified && location.pathname === VERIFY_EMAIL_PATH) {
        const params = new URLSearchParams(location.search);
        return <Navigate to={params.get("returnUrl") || "/overview"} replace />;
    }

    return <>{children}</>;
};

export default Authmiddleware;
